import { Messages } from '../../../../codegen/Localize';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserEditAuthentication } from '../../../actions/spaces/SiteUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectSiteUserGuest } from './IEntityActionHelpers';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';

export const SiteUserSetAuthenticationAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserAuthentication,
  translateName: Messages.authentication_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return ServerSettingsUnauthenticated.isSiteSamlEnabled();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectSiteUserGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditAuthentication(targetItems)
};
